module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/070-cf6729afb358689b405908dbd043d164.jpg";